import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const importProductOtherDutiesApi = createApi({
  reducerPath: "importProductOtherDutiesApi",
  baseQuery,
  tagTypes: ["importProductOtherDuties"], 
  endpoints: (builder) => ({
    createProductOtherDuties: builder.mutation({
      query: ({ id, ...data }) => {

        return {
          url: `import/product/otherDuty/${id}`,
          method: "PUT",
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
          body: {otherDuty:data}, // ✅ send only this
        };
      },
      invalidatesTags: ["importProductOtherDuties"],
    }),

    updateProductOtherDuties: builder.mutation({
      query: ({ id, subId, ...data }) => {
        return {
          url: `import/product/otherDuty/${id}/${subId}`,
          method: "PUT",
          body: {otherDuty:data}, // ✅ send only this

          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
        };
      },
      invalidatesTags: ["importProductOtherDuties"],
    }),

    getProductOtherDutiesId: builder.query({
      query: ({ id }) => `import/product/otherDuty/${id}`,
      transformResponse: (response) => {
        console.log("📥 Raw API Response:", response);
    
        const payload = Array.isArray(response?.data)
          ? response.data[0]   // 🔥 take first object
          : response?.data;
    
        console.log("📤 Transformed Payload:", payload);
    
        return payload;
      },
      providesTags: ["importProductOtherDuties"],
    }),
    
  }),
});

export const {
  useCreateProductOtherDutiesMutation,
  useUpdateProductOtherDutiesMutation,
  useLazyGetProductOtherDutiesIdQuery,
} = importProductOtherDutiesApi;
